import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import Logo from '@/components/Logo/Logo';
import { CenterContainer } from '@/components/CenterContainer/CenterContainer';
import classes from './classes.module.css';

export const Navbar: FC = () => {
  return (
    <nav className={classes.navbar}>
      <CenterContainer className={classes.navContainer}>
        <NavLink to="/multiplication" className={classes.logoLink}>
          <Logo width={48} height={48} />
        </NavLink>
        <div className={classes.navLinks}>
          <NavLink
            to="/multiplication"
            className={({ isActive }) =>
              `${classes.navLink} ${isActive ? classes.active : ''}`
            }
          >
            Multiplication
          </NavLink>
          <NavLink
            to="/addition"
            className={({ isActive }) =>
              `${classes.navLink} ${isActive ? classes.active : ''}`
            }
          >
            Addition
          </NavLink>
        </div>
      </CenterContainer>
    </nav>
  );
};
